import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { formatReceived } from 'utils/formatValues';

export const baseURI = 'configuracion/fundamentos-legales/';

/**
 * GET Fundamentos Legales
 * @returns {Promise<Array<object>>}
 */
export const getFundamentosLegales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Fundamento Legal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getFundamentoLegal = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Fundamento Legal
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFundamentoLegal = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Fundamento Legal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFundamentoLegal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Fundamento Legal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteFundamentoLegal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
